import {domReady} from './Utility/DomReady';
import {SlimSelectController} from './Controllers/SlimSelectController';
import {CountrySwitchController} from './Controllers/CountrySwitchController';
import {CountryRestrictionController} from './CountryRestriction/CountryRestrictionController';
import {CookieBar} from './Components/CookieBar';
import {ArticleController} from './Controllers/ArticleController';
import {NavigationController} from './Controllers/NavigationController';
import {SubmenuSelectController} from './Controllers/SubmenuSelectController';
import {SubmenuButtonController} from './Controllers/SubmenuButtonController';
import {initAllTabs} from './Controllers/TabsController';
import {MagazineHomeController} from './Controllers/MagazineHomeController';
import {NewsletterController} from './Controllers/NewsletterController';
import {Flyout} from './Contact/Flyout';
import {Contactforms} from './Contact/Contactforms';
import {ScrollableHeaderController} from './Controllers/ScrollableHeaderController';
import {SocialShareController} from './Controllers/SocialShareController';
import {initMultipleDownloadButtons} from './Utility/MultipleDownloadButtonUtility';
import {SearchResultsController} from './Controllers/SearchResultsController';
import {ProductDetailController} from './Controllers/ProductDetailController';
import {initTooltips} from './Controllers/TooltipController';
import {adjustScrollPadding} from './Utility/ScrollUtility';
import {initializeLoginKeyRedirect} from './DriveSelection/Utility/LoginRedirectKeyListenerUtility';
import {initAccessProtection} from './Functions/AccessProtection';
import {ApplicationNotesController} from './Controllers/ApplicationNotesController';
import {NavigationShopController} from './Controllers/NavigationShopController';
import {initEventListFilter} from './Functions/EventList';
import {initAnchorNavigation} from './Functions/AnchorNavigation';
import {initVideoHandler} from './Functions/VideoHandler';
import {initSentry} from './sentry';
import {initCalculateLocalTime} from './Functions/CalculateLocalTime';
import {HowToVideosController} from './Controllers/HowToVideosController';
import {formTracking} from './Tracking/FormTracking';
import {initCollapseTextMedia} from './Functions/CollapseTextMedia';

initSentry();

domReady(() => {
  new CookieBar();
  new SlimSelectController();
  new CountrySwitchController();
  new CountryRestrictionController();
  new ArticleController();
  new NavigationController();
  new SubmenuSelectController();
  new SubmenuButtonController();
  initAllTabs();
  new MagazineHomeController();
  new NewsletterController();
  const flyout = new Flyout();
  flyout.initButtonListeners();
  new Contactforms();
  new ScrollableHeaderController();
  new SocialShareController();
  new SearchResultsController();
  new ProductDetailController();
  new ApplicationNotesController();
  new NavigationShopController();
  new HowToVideosController();

  initTooltips();
  initMultipleDownloadButtons();
  adjustScrollPadding();
  initializeLoginKeyRedirect();
  initAccessProtection();
  initEventListFilter();
  initAnchorNavigation();
  initVideoHandler();
  initCalculateLocalTime();
  initCollapseTextMedia();
  formTracking();

  if (document.querySelector('.js-slider')) {
    import(/* webpackChunkName: "Slider" */ './Slider/SliderMain').then(module => {
      new module.SliderMain();
    });
  }
  if (document.querySelector('.js-lightbox')) {
    import(/* webpackChunkName: "Lightbox" */ './Lightbox/LightboxController').then(module => {
      new module.LightboxController();
    });
  }

  if (document.querySelector('.js-worldwide-contact')) {
    import(/* webpackChunkName: "Worldwide" */ './Contact/Worldwide').then(module => {
      new module.Worldwide();
    });
  }

  if (document.querySelector('.js-fdcLight')) {
    import(/* webpackChunkName: "PreselectFormMain" */ './DriveSelection/PreselectFormMain').then(module => {
      new module.PreselectFormMain();
    });
  }

  if (document.querySelector('.js-application-fileupload')) {
    import(/* webpackChunkName: "FileUploadController" */ './Controllers/FileUploadController').then(module => {
      new module.FileUploadController();
    });
  }
});
